document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation so it works even if content loads late
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('read-more-btn')) {
      const btn = e.target;
      const container = btn.previousElementSibling; // Finds the .description-content

      if (container.classList.contains('is-expanded')) {
        // Shrink it
        container.classList.remove('is-expanded');
        btn.textContent = 'Read more...';
        
        // Optional: Scroll back to the top of the description
        container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        // Expand it
        container.classList.add('is-expanded');
        btn.textContent = 'Close';
      }
    }
  });
});